import { Accordion, List, Stack, Text } from "basis";
import { Question } from "./Question";

function Registration({ initiallyOpen }) {
  return (
    <Accordion.Item initiallyOpen={initiallyOpen}>
      <Accordion.Item.Header>Registration</Accordion.Item.Header>
      <Accordion.Item.Content>
        <Stack gap="10">
          <Question title="What is the Latitude Service Centre?">
            <Text>
              The Latitude Service Centre is our new servicing platform which
              replaces individual product specific Online Servicing Centre. The
              Latitude Service Centre allows you to manage all of your Latitude
              Credit Card and Personal Loan accounts, 24 hours a day, with
              access to your account balance, available credit and transaction
              history.
            </Text>
          </Question>
          <Question title="What is my Latitude ID?">
            <Text>
              Your Latitude ID is the email address you used to register for the
              Latitude Mobile app or Latitude Service Centre. Your Latitude ID
              is the username that will be used so you can logon to our
              servicing platforms to manage your Latitude products. The email
              address you use for your Latitude ID must be an email address you
              own, but does not have to be the same as the email address you
              used when signing up for Latitude products.
            </Text>
          </Question>
          <Question title="How do I get started?">
            <Text>
              You will need to create a unique Latitude ID using your email
              address. Once you have successfully completed the registration you
              will be able to link all of your Latitude Credit Card and Personal
              Loan products, so you can see and manage them when you log in to
              Latitude Service Centre or the Latitude app. Latitude creates this
              ID to keep your details secure, and make signing in easy.
            </Text>
          </Question>
          <Question title="What is the difference between the Latitude Service Centre and Latitude Online Service Centre?">
            <Text>
              The Latitude Service Centre is our new servicing platform which
              replaces individual product specific Online Servicing Centre. The
              Latitude Service Centre allows you to manage all of your Latitude
              Credit Card and Personal Loan accounts, 24 hours a day, with
              access to your account balance, available credit and transaction
              history. Currently, the OSC has more features, but the Latitude
              Service Centre will soon catch up. Eventually, the Online Service
              Centre will be decommissioned, but only after the LSC has all the
              same features (and more!).
            </Text>
          </Question>
          <Question title="What should I do if I haven't received my email verification?">
            <List type="ordered">
              <List.Item>Check your inbox</List.Item>
              <List.Item>Confirm your email address</List.Item>
              <List.Item>
                Resend the code to your email (maximum five attempts)
              </List.Item>
            </List>
          </Question>
        </Stack>
      </Accordion.Item.Content>
    </Accordion.Item>
  );
}

export { Registration };
